<template>
  <div class="scanbar-box" ref="s_box">
    <bar-code-scanner
        v-if="isScannerOpen && readerSize"
        :readerSize="readerSize"
        isGlobalScanner="true"
        @orderId="getOrderId"
        @closeScanner="isScannerOpen = !isScannerOpen"
    />
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
    <div class="scanned-prdt" v-if="productDetails">
          <span class="prdt-icon">
            <img v-if="productDetails.itemDTOList[0].itemMediaDTOList.length"
                 :src="productDetails.itemDTOList[0].itemMediaDTOList[0].thumbnail"
                 alt=""
            />
              <img
                  src="../../assets/images/watermark1.jpg"
                  alt="product" v-else
              />
          </span>

      <div class="prdt-info">
        <p>{{productDetails.productName}}</p>
        <div class="price-block">
          <span class="update-price">Rs. {{productDetails.itemDTOList[0].mrp}} </span>
        </div>
      </div>
      <div class="scan-textmsg" @click="addToScannedProductList" >
        Add to Scanned Product List
      </div>

    </div>
    <div class="cntntLoad" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import BarCodeScanner from "@/quagga/BarCodeScanner";
import CustomToaster from "@/components/Common/CustomToaster";
export default {
  name: 'ScanBarCode',

  data() {
    return {
      isScannerOpen: true,
      productDetails: null,
      readerSize: false,
      isToasterData:false,
      toasterData:{},
      loading:false
    };
  },
  components: {
    BarCodeScanner,
    CustomToaster
  },
  mounted() {
    // this.getOrderId('8901725121136')
    this.isScannerOpen = true
    this.productDetails = null
    this.readerSize = {
      width: window.innerWidth,
      height: this.$refs['s_box'].offsetHeight,
    };
  },
  methods: {
    async getOrderId(_orderId){
      this.loading=true;
      this.isScannerOpen =false;
      this.$store.dispatch({
        type: "getProductDetailsByUpcCode",
        upcCode:_orderId
      }).then(data => {
        if(data.data.hasOwnProperty('productName')){
          this.productDetails = data.data;
        }
        else {
          this.toasterData = {
            msg: "No Data Found, Please Try Again",
            color: "#e51c24",
            iconName: "close",
          };
          this.isToasterData= true;
          this.productDetails=null;
          this.isScannerOpen = ! this.isScannerOpen;
        }
        // this.isScannerOpen = true;
        // setTimeout(()=>{
        //   this.productDetails=null;
        // },3000)
        this.loading=false
      }).catch(err => {
        console.log(err);
      });
    },
    addToScannedProductList(){
      if(this.productDetails!==null){
        this.$store.commit('saveScannedProduct', this.productDetails);
      }
      this.toasterData = {
        msg: "Item Added into Scanned Product List Tab",
        color: "#138808",
        iconName: "check",
      };
      this.isScannerOpen = ! this.isScannerOpen;
      this.productDetails=null;
      this.isToasterData= true;
    }
  }

};
</script>
